import Vue from 'vue';
import '@/vendors';
import '@/components/_shared';

import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/filters';

import './styles/index.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
